import React from 'react';
import type { Theme } from 'baseui';
import { useStyletron } from 'baseui';
type DrawingSurfacePropsT = {
  backgroundImage: string | null;
  imageOpacity: number;
};
const getContainerStyles = (theme: Theme, hasImage: boolean) => ({
  width: '100%',
  height: '100%',
  backgroundColor: theme.colors.backgroundPrimary,
  pointerEvents: ('none' as const),
  ...(hasImage && {
    position: ('relative' as const),
    overflow: ('hidden' as const)
  })
});
const getImageStyles = (opacity: number) => ({
  position: ('absolute' as const),
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: ('contain' as const),
  opacity,
  pointerEvents: ('none' as const),
  userSelect: ('none' as const)
});
export function DrawingSurface({
  backgroundImage,
  imageOpacity
}: DrawingSurfacePropsT) {
  const [css, theme] = useStyletron();
  return <div className={css(getContainerStyles(theme, !!backgroundImage))}>
      {backgroundImage && <img src={backgroundImage} alt="" style={getImageStyles(imageOpacity)} draggable={false} data-testid="reference-image" />}
    </div>;
}